<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-btn slot="activator" color="secondary" class="text--primary">Create new admin</v-btn>
            <v-card>

                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Create new admin</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 s12 md12>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.name"
                                            :error-messages="errors.collect('data.name')"
                                            label="Name"
                                            data-vv-name="data.name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 s12 md12>
                                    <v-text-field
                                            v-validate="'required|email'"
                                            v-model="data.email"
                                            :error-messages="errors.collect('data.email')"
                                            label="Email"
                                            data-vv-name="data.email"
                                            v-on:change="debouncedCheckEmail"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 s12 md12>
                                    <v-alert
                                            v-if="error != null"
                                            value="true"
                                            type="error"
                                    >
                                        {{ error }}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Create</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            data : {
                name: '',
                email: ''
            },
            error: null
        }),
        created: function () {
            this.debouncedCheckEmail = _.debounce(this.checkEmail, 200)
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('createAdmin', this.data).then((res) => {
                            this.$emit('created');
                            this.data = {
                                name: '',
                                email: ''
                            };
                            this.dialog = false
                        }).catch((error) => {
                            this.error = error.data.error;
                        });
                    }
                });
            },
            cancel () {
                this.$validator.reset();
                this.dialog = false;
                this.data = {
                    name: '',
                    email: '',
                    error: null
                };
            },
            checkEmail () {
                this.$store.dispatch('checkEmailAdmin', {
                    email: this.data.email
                }).then((res) => {

                }).catch((error) => {
                    this.error = error.data.error;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/config/admins/components/CreateModal.vue